import React, { forwardRef } from 'react';
/**
 * Adds horizontal space between the items used within a `Toolbar`.
 *
 * __Note:__ This component is only compatible with the `Toolbar` component and __not__ with `ToolbarV2`. If you're using `ToolbarV2`, please use `ToolbarSpacerV2` instead.
 */
const ToolbarSpacer = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    style: {
      flexGrow: 1
    },
    className: "spacer",
    ...props,
    "data-component-name": "ToolbarSpacer"
  });
});
ToolbarSpacer.displayName = 'ToolbarSpacer';
export { ToolbarSpacer };